export const INVALID_CHARACTERS = /[<>\\/\0]/;

export const removeSpecialCharacters = (text: string) => {
  return text.replace(new RegExp(INVALID_CHARACTERS.source, 'g'), '');
};
